var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row", staticStyle: { "margin-bottom": "40px" } },
        [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "card bg-light" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", { staticClass: "card-title" }, [
                  _vm._v("Welcome guest"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(
                    "If you don't have an account then you can request one from this page, bla bla bla."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: {
                      href: `/#/organizations/users/requestaccount/${_vm.token}`,
                    },
                  },
                  [_vm._v("Request an account")]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("br"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _vm._v(
              "\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus malesuada enim sit amet urna sollicitudin, vitae condimentum lorem ultricies. Ut suscipit posuere arcu et cursus. Nullam elit felis, fringilla sed imperdiet sed, varius vitae urna. Sed consectetur, dolor in finibus eleifend, odio quam pharetra mauris, ut dapibus eros dolor id dolor. Nunc dignissim ultrices rutrum. Mauris quis sapien in nibh vehicula laoreet. Nullam risus nulla, porttitor eu odio vitae, ultricies laoreet ex. Mauris ultricies varius laoreet.\n                Etiam in tincidunt sapien. Praesent blandit nisi sit amet nunc mollis, in sollicitudin est ultrices. Fusce molestie auctor odio vel feugiat. Phasellus vel pellentesque sem. Pellentesque in mauris sit amet turpis scelerisque faucibus. Proin sed lorem aliquam, congue tortor eget, dignissim metus. Morbi laoreet massa in viverra accumsan. Curabitur mauris ex, pretium ac velit vel, finibus gravida ante. Donec metus sem, porttitor a ex et, ultrices fringilla quam. Aliquam tempus, libero eu rhoncus blandit, purus orci semper nibh, pharetra condimentum neque odio ac eros. Aliquam a tellus in ante scelerisque consectetur at sit amet lacus. Etiam pharetra mauris ipsum, in vulputate nibh viverra vel.\n            "
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("My Big Enterprise")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-3" }, [
          _c("img", {
            attrs: {
              src: "https://www.transparentchoice.com/hubfs/Transparent%20Choice%202021/Home%20Page/Header%20logo.svg",
            },
          }),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card bg-light" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h5", { staticClass: "card-title" }, [_vm._v("Support")]),
        _vm._v(" "),
        _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }, [
          _vm._v("In house: support@mybigenterprise.com"),
        ]),
        _vm._v(" "),
        _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }, [
          _vm._v("Vendor: support@transparentchoice.com"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "card-text" }, [
          _vm._v("In troubles or have some questions please contact support."),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary btn-lg btn-block",
            attrs: { type: "button" },
          },
          [_vm._v("Send ticket")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "card bg-light" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("h5", { staticClass: "card-title" }, [_vm._v("FAQ")]),
        _vm._v(" "),
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("Cras justo odio"),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("Dapibus ac facilisis in"),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _vm._v("Vestibulum at eros"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }